
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'payments-ui-app',
  currentProjectVersion: 'static-1.28600',
  depVersions: {
  "payments-ui-app": "static-1.28600",
  "bend-plugin-arboretum": "static-1.1960",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.505",
  "crm_data": "static-4.93090",
  "data-fetching-client": "static-1.10065",
  "emoji-mart": "static-3.6",
  "enviro": "static-4.455",
  "foundations-components": "static-1.8661",
  "foundations-components-legacy": "static-1.1686",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6009",
  "hs-test-utils": "static-1.8458",
  "hub-http": "static-1.6628",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11910",
  "I18n": "static-7.1693",
  "jasmine-runner": "static-1.6869",
  "quartz": "static-1.7591",
  "raven": "static-3.5925",
  "react-dlb": "static-1.92",
  "react-dnd": "static-2.33",
  "react-dnd-html5-backend": "static-2.10",
  "react-stripe-js": "static-1.119",
  "react-utils": "static-2.5627",
  "reselect": "static-3.15",
  "stripe-js": "static-1.118",
  "ui-components-test-utils": "static-1.6047",
  "UIComponents": "static-3.8856",
  "usage-tracker-public": "static-1.7544",
  "apollo-stack-hubspot": "static-3.94",
  "commerce-subscription-lib": "static-1.37998",
  "payments-checkout-lib": "static-1.523",
  "cssUtils": "static-1.1041",
  "customer-data-objects": "static-1.8113",
  "FireAlarmUi": "static-1.4806",
  "foundations-assets": "static-1.5305",
  "foundations-theming": "static-1.4900",
  "graphql": "static-1.92",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12217",
  "icons": "static-2.699",
  "isMobile": "static-1.7",
  "metrics-js": "static-1.9990",
  "PatternValidationJS": "static-1.3306",
  "property-translator": "static-1.5799",
  "quartz-config": "static-1.1369",
  "quartz-core": "static-1.6810",
  "quartz-i18n": "static-1.1266",
  "quartz-routing": "static-1.1021",
  "quartz-tracking": "static-1.970",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1-fix-undefined-routespec-crash.10",
  "react-select-plus": "static-1.117",
  "react-virtualized": "static-2.111",
  "redux": "static-4.81",
  "redux-thunk": "static-2.83",
  "redux-toolkit": "static-1.81",
  "ReduxMessenger": "static-2.10791",
  "rpc-client-utils": "static-1.5089",
  "sanitize-text": "static-1.8576",
  "SharedI18nStrings": "static-1.186",
  "styled-components": "static-2.100",
  "StyleGuideUI": "static-3.513",
  "superstore": "static-1.5178",
  "transmute": "static-2.97",
  "ui-addon-i18n": "static-1.11565",
  "ui-images": "static-2.1269",
  "usage-tracker-core": "static-1.7583",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3868",
  "quartz-webpack": "static-1.3815",
  "bend-plugin-quartz-routing": "static-1.669",
  "bender-build-tools": "static-1.3518",
  "crm_universal": "static-1.22644",
  "customer-data-email": "static-1.18589",
  "customer-data-ui-utilities": "static-1.10252",
  "dispatcher": "static-1.146",
  "frontend-preferences-client": "static-1.8337",
  "general-store": "static-6.20",
  "native-integrations-shared-strings": "static-1.8181",
  "quick-fetch": "static-1.4195",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4930",
  "floating-ui": "static-1.67",
  "foundations-theming-specialty": "static-1.2616",
  "framer-motion": "static-1.83",
  "hs-story-utils": "static-1.9844",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.90",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1.2953",
  "ui-fonts": "static-1.1172",
  "HeadJS": "static-2.813",
  "hs-test-utils-bend-plugin": "static-1.3569",
  "msw": "static-1.102",
  "msw-config": "static-1.20",
  "testing-library": "static-1.163",
  "hs-locale-management": "static-1.365",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4728",
  "foundations-components-test-utils": "static-1.6144",
  "ui-addon-draggable": "static-3.5165",
  "commerce-billing-lib": "static-1.20439",
  "commerce-shared-components-lib": "static-1.19481",
  "commerce-tools-ui-lib": "static-1.11234",
  "crm-message-bus": "static-1.43997",
  "customer-data-objects-ui-components": "static-1.13449",
  "customer-data-properties": "static-1.52887",
  "growth-payments-core": "static-1.26401",
  "ui-addon-iframeable": "static-1.9497",
  "usage-tracker": "static-1.7733",
  "usage-tracker-container": "static-1.7723",
  "sassPrefix": "static-1.308",
  "inbound-db-properties-service-client": "static-1.4112",
  "foundations-theming-base": "static-1.3885",
  "bend-plugin-foundations-theming": "static-1.3383",
  "stylex": "static-1.45",
  "opentelemetry-fe-types": "static-1-aeastham-default-document-load-user-interaction.5",
  "hub-http-janus": "static-1.898",
  "hubspotter-http": "static-1.4932",
  "mobile-manifest-mixins": "static-1.596",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1-aeastham-default-document-load-user-interaction.5",
  "quartz-auth": "static-1.1266",
  "quartz-head": "static-1.1256",
  "quartz-test": "static-1.1266",
  "trellis-components": "static-1.2972",
  "usage-tracker-session-replay": "static-1.5419",
  "csstype": "static-1.50",
  "web-vitals": "static-1.18",
  "immer": "static-1.104",
  "bend-plugin-chirp-manifest": "static-1.499",
  "chirp-fetch": "static-1.2320",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4892",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.119",
  "FormUrlGenerator": "static-2.5133",
  "sequences-lib": "static-1.8687",
  "apollo-link-hub-http": "static-2.5020",
  "FileManagerCore": "static-1.40247",
  "FileManagerLib": "static-1.40388",
  "hubspot-apollo-client": "static-1.5294",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "salesImages": "static-1.677",
  "timezone-utils": "static-2.5650",
  "ui-gdpr-components": "static-1.10650",
  "react-dnd-compat": "static-1.5030",
  "stylex-utils": "static-1.161",
  "trellis-theming": "static-1.1402",
  "react-flip-move": "static-1.82",
  "avatar-components": "static-1.2902",
  "hs-resources": "static-1.615",
  "pulse": "static-1.1058",
  "utility-belt": "static-1.2955",
  "zustand": "static-1.88",
  "batch-promise": "static-1.1965",
  "customer-data-associations": "static-1.7751",
  "customer-data-property-utils": "static-1.8465",
  "customer-data-tracking": "static-1.7292",
  "framework-data-schema-resolvers": "static-1.7312",
  "framework-data-table": "static-2.12750",
  "object-builder-ui-client": "static-1.49918",
  "payments-enrollment-embed-lib": "static-1.24102",
  "stripe-embedded-components": "static-1.8158",
  "ui-addon-opt": "static-4.8800",
  "ai-components-ui-library": "static-1.9928",
  "customer-data-rte": "static-1.33812",
  "cv-backend-services": "static-1.1607",
  "file-manager-components": "static-1.24748",
  "growth-onboarding-confetti": "static-1.3483",
  "growth-onboarding-empty-states": "static-1.6449",
  "hubspot-prosemirror": "static-1.19184",
  "InboxConnectUtils": "static-4.15753",
  "payment-link-components": "static-1.24345",
  "payments-post-enroll-local-storage-lib": "static-1.5522",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.79",
  "quotes-client-types": "static-1.39085",
  "react-colorpicker": "static-2.10631",
  "ui-addon-upgrades": "static-9.18511",
  "ui-addon-video-player": "static-1.9057",
  "user-context": "static-1.5478",
  "restore-request-side-panel-lib": "static-1.1919",
  "atom": "static-1.5497",
  "reference-resolvers": "static-1.8597",
  "calling-global-api": "static-1.66020",
  "calling-internal-common": "static-1.31741",
  "calling-lifecycle-internal": "static-1.67402",
  "calling-lifecycle-messages": "static-1.59695",
  "commerce-products-lib": "static-1.10768",
  "conditional-properties-service-client": "static-1.4086",
  "crm-index-visualization-core": "static-1.4681",
  "crm-links": "static-1.6723",
  "crm-pipelines-api-client-types": "static-1.4417",
  "customer-data-properties-shared-msw-handlers": "static-1.10138",
  "external-options-client-types": "static-1.4413",
  "formula-editor": "static-1.14936",
  "google-libphonenumber": "static-1.48",
  "inbound-db-meta-service-client": "static-1.3744",
  "inbounddb-objects-service-types": "static-1.4494",
  "meetings-icalendar-utils-lib": "static-1.1056",
  "multi-currency-client-types": "static-1.3981",
  "pipeline-validation-client-types": "static-1.4253",
  "property-value-citations": "static-1.3501",
  "reference-resolvers-lite": "static-1.8525",
  "smart-data-capture-core": "static-1.359",
  "smart-property-lib": "static-1.8528",
  "tiered-pricing": "static-1.2147",
  "topics-actions-lib": "static-1.594",
  "trial-components-library": "static-1.14293",
  "ui-addon-form-validation": "static-1.11339",
  "laboratory-lib": "static-3.7570",
  "onboarding-scopes": "static-1.6871",
  "seat-types-lib": "static-1.947",
  "magpie-lib": "static-1.5854",
  "navigation-messaging": "static-1.8390",
  "ts-schema": "static-1.4364",
  "hub-http-shared-msw-handlers": "static-1.10811",
  "hubspotter-http-shared-msw-handlers": "static-1.10809",
  "base-ui": "static-1.26",
  "react-day-picker": "static-1.14",
  "tanstack-virtual": "static-1.42",
  "amplitude-session-replay-browser": "static-1.60",
  "sequences-client-types-lib": "static-1.8544",
  "breeze-artifacts-sdk": "static-1.685",
  "copilot-toolkit": "static-1.12049",
  "audio-components": "static-1.6494",
  "ContentUtils": "static-1.69348",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29980",
  "FileManagerImages": "static-1.37899",
  "html-to-image": "static-1.64",
  "immerable": "static-1.4561",
  "ui-universal-auth": "static-1.9625",
  "urlinator": "static-1.4936",
  "video-components": "static-1.14337",
  "video-data-lib": "static-1.35993",
  "video-embed": "static-1.36827",
  "hubspot-apollo-cache": "static-1.753",
  "event-emitter": "static-1.1378",
  "framework-builder-read-service-client": "static-1.4292",
  "fdsr-migration-layer": "static-1.431",
  "bend-plugin-pulse": "static-1.561",
  "fast-json-patch": "static-1.73",
  "framework-data-schema-quick-fetch": "static-1.7217",
  "persist-promise": "static-1.4122",
  "customer-data-reference-ui-components": "static-1.13586",
  "tasks-actions-lib": "static-1.340",
  "reporting-data": "static-1.69190",
  "purchase-motions-components": "static-1.6564",
  "growth-onboarding-feedback-components": "static-1.7002",
  "growth-onboarding-reliability": "static-1.5502",
  "marketplace-ui-apps-core": "static-1.19493",
  "onboarding-tours": "static-1.17304",
  "stripe-connect-js": "static-1.81",
  "chatspot-core": "static-1.23516",
  "content-assistance-lib": "static-1.8346",
  "draft-content-plugins": "static-1.29070",
  "draft-convert": "static-2.83",
  "draft-extend": "static-3.87",
  "draft-js": "static-5.89",
  "draft-plugins": "static-2.22276",
  "rich-text-lib": "static-1.20473",
  "breeze-engine-lib": "static-1.2011",
  "poll-commands": "static-1.3892",
  "video-components-external": "static-1.12335",
  "trellis-story-utils": "static-1.4922",
  "ui-addon-react-router-dom": "static-1.9948",
  "content-media-capture": "static-1.5683",
  "knowledge-content-types": "static-1.8703",
  "ui-addon-emoji-picker": "static-1.10286",
  "ui-business-units-lib": "static-1.9514",
  "ui-shepherd-react": "static-3.10694",
  "hub-http-contrib": "static-1.3447",
  "ui-addon-sales-email": "static-1.5622",
  "commerce-tours-lib": "static-1.6784",
  "getting-started-shared-tasks": "static-1.19468",
  "sales-checkout-service-client": "static-1.3949",
  "merchandise-lib": "static-1.283",
  "getting-started-shared-tasks-store": "static-1.18586",
  "onboarding-tours-utils": "static-1.1371",
  "calling-error-reporting": "static-1.31748",
  "shared-worker-versioning": "static-1.11460",
  "calling-usage-tracker": "static-1.6954",
  "voice-sms-access-library": "static-1.2317",
  "conversations-skeleton-state": "static-1.7602",
  "commerce-permissions": "static-1.1196",
  "products-iframe-lib": "static-1.8806",
  "products-ui-components-shared-msw-handlers": "static-1.11193",
  "crm-index-associations-lib": "static-1.6868",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10894",
  "sales-views-client-types": "static-1.4678",
  "location-customization-utils-lib": "static-1.10323",
  "bark-lib": "static-1.16949",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.105",
  "crm-properties-common-lib": "static-1.6308",
  "react-codemirror": "static-1.11059",
  "data-agent-kit": "static-1.809",
  "data-token-picker": "static-1.17046",
  "markdown-it": "static-1.6",
  "fsm": "static-1.4173",
  "policy-lib": "static-1.7226",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10957",
  "embedded-academy-lib": "static-1.15851",
  "hubs-service-types": "static-1.1684",
  "navigation-components": "static-1.19063",
  "nudge-client-utils": "static-1.3321",
  "purchase-motions-api": "static-1.6567",
  "signup-constants": "static-1.19845",
  "idb-keyval": "static-1.54",
  "magpie-types": "static-1.5314",
  "reactive-lib": "static-1.1142",
  "simple-logging-lib": "static-1.3471",
  "cms-field-types": "static-1.5231",
  "content-icons-ui": "static-1.2417",
  "integrations-lib": "static-1.17305",
  "underscore": "static-1.8",
  "unified-auth-core-lib": "static-1.1421",
  "social-insights-client-types": "static-1.22840",
  "outpost": "static-1.4553",
  "reporting-client-types": "static-1.2784",
  "signup-ui-url-generator": "static-2.8478",
  "developer-experience-shared-components": "static-1.10956",
  "immutable-less": "static-1.5069",
  "marketplace-ui-client-types": "static-1.18368",
  "marketplace-ui-common": "static-1.20961",
  "ui-addon-integrations-directory-panel": "static-2.8388",
  "ui-extensibility-client-types": "static-1.4336",
  "growth-data-modal": "static-1.6054",
  "growth-onboarding-next-action-utils": "static-1.2892",
  "onboarding-tours-client": "static-1.5519",
  "ui-shepherd-tracker": "static-1.8075",
  "ui-coaching-tips": "static-1.29511",
  "breeze-engine-chat-components": "static-1.989",
  "breeze-engine-core": "static-1.1289",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "content-media-composition-data-lib": "static-1.13487",
  "content-media-compositions": "static-2.17494",
  "media-bridge-lib": "static-1.19561",
  "fix-webm-duration": "static-1.33",
  "notification-sounds": "static-1.4844",
  "calling-orchestration-schema": "static-1.37094",
  "crm-record-cards-service-types": "static-1.3834",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16573",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.114",
  "storybook-react": "static-1.43",
  "academy-common-lib": "static-1.15311",
  "nest": "static-1.653",
  "nudge-custom-function-registry": "static-1.3078",
  "nudge-renderer-utils": "static-1.3397",
  "whisper-core-api": "static-1.7540",
  "flux-actions": "static-1.379",
  "integrations-error-boundary-lib": "static-1.14720",
  "integrations-tracking-lib": "static-1.6031",
  "redux-observable": "static-1.78",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.1139",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4597",
  "ai-settings-ui-library": "static-1.8499",
  "nav-meta": "static-1.30700",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1433",
  "onboarding-data-sync-lib": "static-1.2753",
  "growth-onboarding-next-action-components": "static-1.2920",
  "user-context-client": "static-1.4928",
  "js-cookie": "static-1.18",
  "academy-service-client": "static-1.4112",
  "croppie": "static-2.10",
  "final-form": "static-1.82",
  "SafeStorage": "static-1.4813",
  "trellis-ecosystem": "static-1.7773",
  "wootric-nps": "static-1.7266",
  "universal-page-editor-lib": "static-1.3429",
  "adobe-sign-auth-lib": "static-1.670",
  "ads-unified-auth-lib": "static-1.1774",
  "custom-vendor-connection-lib": "static-1.189",
  "google-sheets-integration-lib": "static-1.1235",
  "microsoft-drive-auth-lib": "static-1.397",
  "surveymonkey-integration-lib": "static-1.766",
  "slack-ui-library": "static-1.10816",
  "settings-ui-lib": "static-1.12949",
  "simple-data-table": "static-1.3729",
  "meetings-connect-utils-lib": "static-1.8035"
},
  depPathPrefixes: {
  "payments-ui-app": "/payments-ui-app/static-1.28600",
  "bend-plugin-arboretum": "/bend-plugin-arboretum/static-1.1960",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.505",
  "crm_data": "/crm_data/static-4.93090",
  "data-fetching-client": "/data-fetching-client/static-1.10065",
  "emoji-mart": "/emoji-mart/static-3.6",
  "enviro": "/enviro/static-4.455",
  "foundations-components": "/foundations-components/static-1.8661",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1686",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6009",
  "hs-test-utils": "/hs-test-utils/static-1.8458",
  "hub-http": "/hub-http/static-1.6628",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11910",
  "I18n": "/I18n/static-7.1693",
  "jasmine-runner": "/jasmine-runner/static-1.6869",
  "quartz": "/quartz/static-1.7591",
  "raven": "/raven/static-3.5925",
  "react-dlb": "/react-dlb/static-1.92",
  "react-dnd": "/react-dnd/static-2.33",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "react-stripe-js": "/react-stripe-js/static-1.119",
  "react-utils": "/react-utils/static-2.5627",
  "reselect": "/reselect/static-3.15",
  "stripe-js": "/stripe-js/static-1.118",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6047",
  "UIComponents": "/UIComponents/static-3.8856",
  "usage-tracker-public": "/usage-tracker-public/static-1.7544",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37998",
  "payments-checkout-lib": "/payments-checkout-lib/static-1.523",
  "cssUtils": "/cssUtils/static-1.1041",
  "customer-data-objects": "/customer-data-objects/static-1.8113",
  "FireAlarmUi": "/FireAlarmUi/static-1.4806",
  "foundations-assets": "/foundations-assets/static-1.5305",
  "foundations-theming": "/foundations-theming/static-1.4900",
  "graphql": "/graphql/static-1.92",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12217",
  "icons": "/icons/static-2.699",
  "isMobile": "/isMobile/static-1.7",
  "metrics-js": "/metrics-js/static-1.9990",
  "PatternValidationJS": "/PatternValidationJS/static-1.3306",
  "property-translator": "/property-translator/static-1.5799",
  "quartz-config": "/quartz-config/static-1.1369",
  "quartz-core": "/quartz-core/static-1.6810",
  "quartz-i18n": "/quartz-i18n/static-1.1266",
  "quartz-routing": "/quartz-routing/static-1.1021",
  "quartz-tracking": "/quartz-tracking/static-1.970",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1-fix-undefined-routespec-crash.10",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-virtualized": "/react-virtualized/static-2.111",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.83",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "ReduxMessenger": "/ReduxMessenger/static-2.10791",
  "rpc-client-utils": "/rpc-client-utils/static-1.5089",
  "sanitize-text": "/sanitize-text/static-1.8576",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "styled-components": "/styled-components/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.513",
  "superstore": "/superstore/static-1.5178",
  "transmute": "/transmute/static-2.97",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11565",
  "ui-images": "/ui-images/static-2.1269",
  "usage-tracker-core": "/usage-tracker-core/static-1.7583",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3868",
  "quartz-webpack": "/quartz-webpack/static-1.3815",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.669",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "crm_universal": "/crm_universal/static-1.22644",
  "customer-data-email": "/customer-data-email/static-1.18589",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10252",
  "dispatcher": "/dispatcher/static-1.146",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8337",
  "general-store": "/general-store/static-6.20",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8181",
  "quick-fetch": "/quick-fetch/static-1.4195",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4930",
  "floating-ui": "/floating-ui/static-1.67",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2616",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-story-utils": "/hs-story-utils/static-1.9844",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.90",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1.2953",
  "ui-fonts": "/ui-fonts/static-1.1172",
  "HeadJS": "/HeadJS/static-2.813",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3569",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.20",
  "testing-library": "/testing-library/static-1.163",
  "hs-locale-management": "/hs-locale-management/static-1.365",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4728",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6144",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5165",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20439",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19481",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11234",
  "crm-message-bus": "/crm-message-bus/static-1.43997",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13449",
  "customer-data-properties": "/customer-data-properties/static-1.52887",
  "growth-payments-core": "/growth-payments-core/static-1.26401",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9497",
  "usage-tracker": "/usage-tracker/static-1.7733",
  "usage-tracker-container": "/usage-tracker-container/static-1.7723",
  "sassPrefix": "/sassPrefix/static-1.308",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4112",
  "foundations-theming-base": "/foundations-theming-base/static-1.3885",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3383",
  "stylex": "/stylex/static-1.45",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1-aeastham-default-document-load-user-interaction.5",
  "hub-http-janus": "/hub-http-janus/static-1.898",
  "hubspotter-http": "/hubspotter-http/static-1.4932",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.596",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1-aeastham-default-document-load-user-interaction.5",
  "quartz-auth": "/quartz-auth/static-1.1266",
  "quartz-head": "/quartz-head/static-1.1256",
  "quartz-test": "/quartz-test/static-1.1266",
  "trellis-components": "/trellis-components/static-1.2972",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5419",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.18",
  "immer": "/immer/static-1.104",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.499",
  "chirp-fetch": "/chirp-fetch/static-1.2320",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4892",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.119",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5133",
  "sequences-lib": "/sequences-lib/static-1.8687",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5020",
  "FileManagerCore": "/FileManagerCore/static-1.40247",
  "FileManagerLib": "/FileManagerLib/static-1.40388",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5294",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "salesImages": "/salesImages/static-1.677",
  "timezone-utils": "/timezone-utils/static-2.5650",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10650",
  "react-dnd-compat": "/react-dnd-compat/static-1.5030",
  "stylex-utils": "/stylex-utils/static-1.161",
  "trellis-theming": "/trellis-theming/static-1.1402",
  "react-flip-move": "/react-flip-move/static-1.82",
  "avatar-components": "/avatar-components/static-1.2902",
  "hs-resources": "/hs-resources/static-1.615",
  "pulse": "/pulse/static-1.1058",
  "utility-belt": "/utility-belt/static-1.2955",
  "zustand": "/zustand/static-1.88",
  "batch-promise": "/batch-promise/static-1.1965",
  "customer-data-associations": "/customer-data-associations/static-1.7751",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8465",
  "customer-data-tracking": "/customer-data-tracking/static-1.7292",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7312",
  "framework-data-table": "/framework-data-table/static-2.12750",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49918",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24102",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8158",
  "ui-addon-opt": "/ui-addon-opt/static-4.8800",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9928",
  "customer-data-rte": "/customer-data-rte/static-1.33812",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "file-manager-components": "/file-manager-components/static-1.24748",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3483",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6449",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19184",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15753",
  "payment-link-components": "/payment-link-components/static-1.24345",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5522",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.79",
  "quotes-client-types": "/quotes-client-types/static-1.39085",
  "react-colorpicker": "/react-colorpicker/static-2.10631",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18511",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "user-context": "/user-context/static-1.5478",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1919",
  "atom": "/atom/static-1.5497",
  "reference-resolvers": "/reference-resolvers/static-1.8597",
  "calling-global-api": "/calling-global-api/static-1.66020",
  "calling-internal-common": "/calling-internal-common/static-1.31741",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67402",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59695",
  "commerce-products-lib": "/commerce-products-lib/static-1.10768",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4086",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4681",
  "crm-links": "/crm-links/static-1.6723",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4417",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10138",
  "external-options-client-types": "/external-options-client-types/static-1.4413",
  "formula-editor": "/formula-editor/static-1.14936",
  "google-libphonenumber": "/google-libphonenumber/static-1.48",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3744",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4494",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1056",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3981",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4253",
  "property-value-citations": "/property-value-citations/static-1.3501",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8525",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.359",
  "smart-property-lib": "/smart-property-lib/static-1.8528",
  "tiered-pricing": "/tiered-pricing/static-1.2147",
  "topics-actions-lib": "/topics-actions-lib/static-1.594",
  "trial-components-library": "/trial-components-library/static-1.14293",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11339",
  "laboratory-lib": "/laboratory-lib/static-3.7570",
  "onboarding-scopes": "/onboarding-scopes/static-1.6871",
  "seat-types-lib": "/seat-types-lib/static-1.947",
  "magpie-lib": "/magpie-lib/static-1.5854",
  "navigation-messaging": "/navigation-messaging/static-1.8390",
  "ts-schema": "/ts-schema/static-1.4364",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10811",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10809",
  "base-ui": "/base-ui/static-1.26",
  "react-day-picker": "/react-day-picker/static-1.14",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8544",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.685",
  "copilot-toolkit": "/copilot-toolkit/static-1.12049",
  "audio-components": "/audio-components/static-1.6494",
  "ContentUtils": "/ContentUtils/static-1.69348",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29980",
  "FileManagerImages": "/FileManagerImages/static-1.37899",
  "html-to-image": "/html-to-image/static-1.64",
  "immerable": "/immerable/static-1.4561",
  "ui-universal-auth": "/ui-universal-auth/static-1.9625",
  "urlinator": "/urlinator/static-1.4936",
  "video-components": "/video-components/static-1.14337",
  "video-data-lib": "/video-data-lib/static-1.35993",
  "video-embed": "/video-embed/static-1.36827",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.753",
  "event-emitter": "/event-emitter/static-1.1378",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4292",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.431",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.561",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7217",
  "persist-promise": "/persist-promise/static-1.4122",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13586",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.340",
  "reporting-data": "/reporting-data/static-1.69190",
  "purchase-motions-components": "/purchase-motions-components/static-1.6564",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7002",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5502",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19493",
  "onboarding-tours": "/onboarding-tours/static-1.17304",
  "stripe-connect-js": "/stripe-connect-js/static-1.81",
  "chatspot-core": "/chatspot-core/static-1.23516",
  "content-assistance-lib": "/content-assistance-lib/static-1.8346",
  "draft-content-plugins": "/draft-content-plugins/static-1.29070",
  "draft-convert": "/draft-convert/static-2.83",
  "draft-extend": "/draft-extend/static-3.87",
  "draft-js": "/draft-js/static-5.89",
  "draft-plugins": "/draft-plugins/static-2.22276",
  "rich-text-lib": "/rich-text-lib/static-1.20473",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2011",
  "poll-commands": "/poll-commands/static-1.3892",
  "video-components-external": "/video-components-external/static-1.12335",
  "trellis-story-utils": "/trellis-story-utils/static-1.4922",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9948",
  "content-media-capture": "/content-media-capture/static-1.5683",
  "knowledge-content-types": "/knowledge-content-types/static-1.8703",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10286",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9514",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10694",
  "hub-http-contrib": "/hub-http-contrib/static-1.3447",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5622",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6784",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19468",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3949",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18586",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1371",
  "calling-error-reporting": "/calling-error-reporting/static-1.31748",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11460",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6954",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2317",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "commerce-permissions": "/commerce-permissions/static-1.1196",
  "products-iframe-lib": "/products-iframe-lib/static-1.8806",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11193",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6868",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10894",
  "sales-views-client-types": "/sales-views-client-types/static-1.4678",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10323",
  "bark-lib": "/bark-lib/static-1.16949",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.105",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6308",
  "react-codemirror": "/react-codemirror/static-1.11059",
  "data-agent-kit": "/data-agent-kit/static-1.809",
  "data-token-picker": "/data-token-picker/static-1.17046",
  "markdown-it": "/markdown-it/static-1.6",
  "fsm": "/fsm/static-1.4173",
  "policy-lib": "/policy-lib/static-1.7226",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10957",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15851",
  "hubs-service-types": "/hubs-service-types/static-1.1684",
  "navigation-components": "/navigation-components/static-1.19063",
  "nudge-client-utils": "/nudge-client-utils/static-1.3321",
  "purchase-motions-api": "/purchase-motions-api/static-1.6567",
  "signup-constants": "/signup-constants/static-1.19845",
  "idb-keyval": "/idb-keyval/static-1.54",
  "magpie-types": "/magpie-types/static-1.5314",
  "reactive-lib": "/reactive-lib/static-1.1142",
  "simple-logging-lib": "/simple-logging-lib/static-1.3471",
  "cms-field-types": "/cms-field-types/static-1.5231",
  "content-icons-ui": "/content-icons-ui/static-1.2417",
  "integrations-lib": "/integrations-lib/static-1.17305",
  "underscore": "/underscore/static-1.8",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1421",
  "social-insights-client-types": "/social-insights-client-types/static-1.22840",
  "outpost": "/outpost/static-1.4553",
  "reporting-client-types": "/reporting-client-types/static-1.2784",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8478",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10956",
  "immutable-less": "/immutable-less/static-1.5069",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18368",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20961",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8388",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4336",
  "growth-data-modal": "/growth-data-modal/static-1.6054",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2892",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5519",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8075",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29511",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.989",
  "breeze-engine-core": "/breeze-engine-core/static-1.1289",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13487",
  "content-media-compositions": "/content-media-compositions/static-2.17494",
  "media-bridge-lib": "/media-bridge-lib/static-1.19561",
  "fix-webm-duration": "/fix-webm-duration/static-1.33",
  "notification-sounds": "/notification-sounds/static-1.4844",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37094",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3834",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16573",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.114",
  "storybook-react": "/storybook-react/static-1.43",
  "academy-common-lib": "/academy-common-lib/static-1.15311",
  "nest": "/nest/static-1.653",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3078",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3397",
  "whisper-core-api": "/whisper-core-api/static-1.7540",
  "flux-actions": "/flux-actions/static-1.379",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14720",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6031",
  "redux-observable": "/redux-observable/static-1.78",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.1139",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8499",
  "nav-meta": "/nav-meta/static-1.30700",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1433",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2753",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2920",
  "user-context-client": "/user-context-client/static-1.4928",
  "js-cookie": "/js-cookie/static-1.18",
  "academy-service-client": "/academy-service-client/static-1.4112",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.82",
  "SafeStorage": "/SafeStorage/static-1.4813",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7773",
  "wootric-nps": "/wootric-nps/static-1.7266",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3429",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.670",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1774",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.189",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1235",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.397",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.766",
  "slack-ui-library": "/slack-ui-library/static-1.10816",
  "settings-ui-lib": "/settings-ui-lib/static-1.12949",
  "simple-data-table": "/simple-data-table/static-1.3729",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8035"
}
};
